export default __webpack_public_path__ + "static/media/golf.18047303.png";